import { connect } from 'react-redux';
import { addLocaleData, IntlProvider } from 'react-intl';
import englishLocaleData from 'react-intl/locale-data/en';
import arabicLocaleData from 'react-intl/locale-data/ar';

addLocaleData(englishLocaleData);
addLocaleData(arabicLocaleData);

const mapStateToProps = ({ rootReducer }) => {
  const { locale, messages } = rootReducer.language;
  return { key: locale, locale, messages };
};

export default connect(mapStateToProps)(IntlProvider);
